<template>
  <div>
    <mf-button label="Exportar clientes" @click="value = true" />

    <v-dialog v-model="value" width="700">
      <v-card class="card-select-flyers">
        <v-card-title> Exportar clientes do site de cadastramento </v-card-title>

        <v-card-text>
          <v-row align="center" justify="center">
            <v-col>
              <mf-date-range-picker label="Data inicial - Data final" :initial-date.sync="initialDate" :final-date.sync="endDate" />
            </v-col>
          </v-row>
          <mf-action-buttons
            :primary-button="{
              text: 'Exportar',
              action: exportClients,
              isVisible: true,
              isDisabled: !disableExport() || $wait.any,
              isLoading: $wait.is('get-hotsite-customers'),
            }"
            :extra-button="{
              text: 'Cancelar',
              action: () => (value = false),
              isVisible: true,
              isDisabled: $wait.any,
            }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapWaitingActions } from 'vue-wait'

export default {
  data: () => ({
    value: false,
    initialDate: '',
    endDate: '',
    filter: '',
  }),
  computed: {},
  methods: {
    ...mapWaitingActions({
      getHotsiteCustomers: 'get-hotsite-customers',
    }),
    putDates(isFirstDate) {
      if (isFirstDate) this.endDate = null
    },
    exportClients() {
      this.filter = `${this.initialDate},${this.endDate}`
      this.getHotsiteCustomers({ date: this.filter }).catch(() => {
        this.$snackbar({ message: 'Erro ao exportar clientes', snackbarColor: 'error' })
      })
    },

    disableExport() {
      return Boolean(this.initialDate) && Boolean(this.endDate)
    },
  },
}
</script>
